"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CGPPointMutator = void 0;
const CGPProgram_1 = require("./CGPProgram");
class CGPPointMutator {
    constructor(config) {
        this.config = config;
    }
    mutate(programIn) {
        let newProgram = (0, CGPProgram_1.cloneCGPProgram)(programIn);
        // TODO: Remove magic number:
        for (let i = 0; i < 3; i++) {
            newProgram = this.pointMutate(newProgram);
        }
        return newProgram;
    }
    pointMutate(program) {
        // Ok, so the fun part.
        // We treat it by ALLELLE, not NODE
        // Middle nodes have N+1 alleles, output nodes have 1
        const middleAlleles = (this.config.nodeInputCount + 1);
        const alleleCount = this.config.numMiddleNodes * middleAlleles + this.config.numOutputs;
        // Pick one
        const chosenAllele = Math.floor(Math.random() * alleleCount);
        // Figure out what it is:
        if (chosenAllele < this.config.numMiddleNodes * middleAlleles) {
            // It's a middle node:
            const nodeIdx = Math.floor(chosenAllele / middleAlleles);
            const piece = chosenAllele % middleAlleles;
            if (piece === 0) {
                program.middleNodes[nodeIdx].operator = (0, CGPProgram_1.asOpIndex)(Math.floor(Math.random() * 10000));
            }
            else {
                program.middleNodes[nodeIdx].inputIndexes[piece - 1] = (0, CGPProgram_1.asNodeIndex)(Math.floor(Math.random() * 10000));
            }
        }
        else {
            // It's an output node:
            const nodeIdx = chosenAllele - this.config.numMiddleNodes * middleAlleles;
            program.outputs[nodeIdx] = (0, CGPProgram_1.asNodeIndex)(Math.floor(Math.random() * 10000));
        }
        return program;
    }
}
exports.CGPPointMutator = CGPPointMutator;
